import React, { Component } from "react";
import autoBind from "auto-bind";

class Select2 extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    this._initSelect2();
  }

  componentDidUpdate() {
    this._initSelect2();
  }

  componentWillUnmount() {
    this._destroySelect2();
  }

  render() {
    let optionTags;

    if ( this.props.options ) {
      optionTags = this.props.options.map(function(option) {
        return (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        );
      });
    } else if ( this.props.optionsGrouped ) {
      optionTags = this.props.optionsGrouped.map((group) => (
        <optgroup label={ group.label } key={ group.label }>
          {
            group.options.map((option) => (
              <option value={ option.value } key={ option.value }>
                { option.label }
              </option>
            ))
          }
        </optgroup>
      ));
    }

    return (
      <select
        ref={(n) => { this._rootNode = n; }}
        className="form-control"
        defaultValue={this.props.value}
        onChange={this._onChange}
      >
        {optionTags}
      </select>
    );
  }

  _onChange(e) {
    this.props.onChange(e.target.value, $(e.target).find("option:selected").text());
  }

  _onBlur(e) {
    if ( this.props.onBlur ) this.props.onBlur();
  }

  _initSelect2() {
    if (this._$ele) {
      this._$ele = null;
    }

    const rootNode = this._rootNode;
    const $select = $("select", rootNode).add($(rootNode).filter("select"));

    const $ele = $select.select2({
      width: this.props.width ? this.props.width : "100%",
      minimumInputLength: 0,
      minimumResultsForSearch: this.props.search === false ? -1 : 0,
    });

    if (this.props.select2StartOpen) {
      $ele.select2("open");
    }

    $ele.on("change", this._onChange);
    $ele.on("select2:close", this._onBlur);

    this._$ele = $ele;
  }

  _destroySelect2() {
    if (this._$ele) {
      // Let the current rendering pass finish prior to removing the Select2
      // dropdown - otherwise this generates an error when the render reaches
      // the Select2 code.
      this._$ele.siblings(".select2-container").hide();
      this._$ele.hide();
      setTimeout(() => {
        this._$ele.select2("destroy");
        this._$ele = null;
      }, 0);
    }
  }
}

export default Select2;
